import { deleteObject, getObject, postObject, putObject } from "../ChoiceApi";
import { IResult } from "../Models/Result";
export interface ISentinelApiKey {
    sentinelApiKeyID: number;
    sentinelApiKey: string;
    webserviceAccount: string;
    sentinelKeyDescription?: string;
    databaseKey: string;
    databaseName?: string;
    rateLimitPerHour: number;
    sentinelApplication: SentinelApplication;
    createdDateTimeUTC: string;
    isActive: boolean;
}

export interface ISentinelNewKey {
    webserviceAccount: string;
    sentinelKeyDescription?: string;
    databaseKey: string;
    rateLimitPerHour: number;
    sentinelRouteIds: number[];
}

export interface IUpdateSentinelKeyRequest {
    sentinelKeyDescription?: string;
    rateLimitPerHour: number;
    isActive: boolean;
}
export interface ICompanies {
    database_id: number;
    database_name: string;
    database_key: string;
    database_alias: string;
    active: string;
}
export interface ISentinelRoute{
    sentinelRouteId: number;
    routeName: string;
    routeDescription: string;
    sectionName: string;
    selected: boolean;
}
export interface ISentinelRouteMap{
    sentinelApiKeyId: number;
    sentinelRouteId: number;
}
export interface IWebserviceAccounts{
    account_id: number;
    account: string;
    description: string;
}
//enums
export enum SentinelApplication{
    Choice = "Choice"
}
const SentinelURL = "api/SentinelKeys/";
export async function getKey(id: number):Promise<ISentinelApiKey | undefined>{
    return await getObject<ISentinelApiKey | undefined>(SentinelURL+id);
}
export async function getAllKeys():Promise<ISentinelApiKey[] | undefined>{
    return await getObject<ISentinelApiKey[] | undefined>(SentinelURL);
}
export async function updateKey(id:number, key:IUpdateSentinelKeyRequest):Promise<IResult | undefined>{
    return await putObject(SentinelURL+id, key);
}
export async function deleteKey(id:number){
   return await deleteObject(SentinelURL+id);
}
export async function generateKey(newKey:ISentinelNewKey):Promise<IResult | undefined>{
    return await postObject(SentinelURL+"Generate",newKey);
}
export async function getAllCompanies():Promise<ICompanies[] | undefined>{
    return await getObject("api/Companies");
}
export async function getSentinelRoute():Promise<ISentinelRoute[] | undefined>{
    return await getObject(SentinelURL+"Route");
}
export async function getSentinelRouteMap():Promise<ISentinelRouteMap[] | undefined>{
    return await getObject(SentinelURL+"RouteMap");
}
export async function updateMap(id:number, key:number[]):Promise<IResult | undefined>{
    return await postObject(SentinelURL+"RouteMap/"+id, key);
}
export async function getAllWebserviceAccounts():Promise<IWebserviceAccounts[] | undefined>{
    return await getObject(SentinelURL+"WebserviceAccounts");
}